import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { CCard, CCardBody } from "@coreui/react-pro";
import { DocumentToc } from "../../components/markdown/DocumentToc";
import { NotFound } from "../NotFound";
import { getLegalPage } from "./legal-content";
import { LegalDocumentBody } from "./LegalDocumentBody";

export function LegalPage({ slug }: { slug: string }) {
  const { t } = useTranslation();
  const bodyRef = useRef<HTMLDivElement>(null);
  const doc = getLegalPage(slug);

  // Only reachable by editing the route table with a slug the package does not
  // publish, but a legal page that renders blank is worse than an honest 404.
  if (!doc) return <NotFound />;

  return (
    <div className="help-article-layout">
      <div className="help-article-header">
        <h1 className="mb-2">{doc.heading}</h1>
        <p className="help-article-meta font-monospace text-body-secondary">
          <span>Scryer Labs</span>
          <span aria-hidden="true">·</span>
          <span>{t("legal.lastUpdated", { date: doc.lastUpdated })}</span>
        </p>
      </div>

      <div className="help-article-page">
        <CCard>
          <CCardBody>
            <div className="help-article legal-article" ref={bodyRef}>
              <LegalDocumentBody body={doc.body} />
            </div>
          </CCardBody>
        </CCard>
      </div>

      <DocumentToc
        key={doc.slug}
        containerRef={bodyRef}
        title={t("legal.contents")}
        // h2 only: these documents run to nineteen sections, and including every
        // sub-clause makes a rail longer than the viewport it has to sit in.
        headingSelector="h2[id]"
        labelAttribute="data-toc-label"
      />
    </div>
  );
}
